<template>
  <div class="a-input-block">
    <div class="a-input-head">
      <div class="a-input-label">{{ label }}</div>
    </div>
    <div class="a-input-body" @click="$emit('click')">
      <div class="a-input">{{ value }}</div>
      <div v-show="!value" class="a-input-placeholder">{{ placeholder }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'label',
      'value',
      'placeholder'
    ]
  };
</script>



// WEBPACK FOOTER //
// src/components/c-block-input.vue